import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import CustomScrollbars from 'util/CustomScrollbars';
import Navigation from 'components/Navigation';
import { useAcesso } from 'util/permissoes/useAcesso';

import { getMenuDoModulo, getTemaDoModulo } from './menus';
import useModuleTheme from './useModuleTheme';

const SideBarContent = () => {
  const location = useLocation();
  const authUserInfo = useSelector(({ auth }) => auth.authUserInfo);
  const podeAcessar = useAcesso();

  useModuleTheme(getTemaDoModulo(location.pathname));

  return (
    <CustomScrollbars className=" scrollbar">
      <Navigation
        menuItems={getMenuDoModulo(
          location.pathname,
          podeAcessar,
          authUserInfo
        )}
      />
    </CustomScrollbars>
  );
};

export default SideBarContent;
